<template>
  <div class="modal commFeed">
    <div class="box">
      <div class="top">
        <div class="title">Comentar</div>
        <div class="close" @click="emits('close')"><i class="fa-solid fa-xmark"></i></div>
      </div>
      <div class="content">
        <form @submit="RePost">
          <textarea name="text" placeholder="Comente..." minlength="5" v-model="text"></textarea>
          <button :disabled="sending">{{ sending ? 'Enviando...' : 'Comentar' }}</button>
        </form>
      </div>
    </div>
    <Transition name="slide-fade">
      <Alerta v-if="textA !== ''" :text="textA" />
    </Transition>
  </div>
</template>

<script setup>

import { postCommentResponse } from '@/services/api.js'
import Alerta from '../usefulness/alert.vue'
import { ref } from 'vue'

const emits = defineEmits(['close'])
const props = defineProps(['id', 'post_id', 'type'])

const text = ref('')
const textA = ref('')
const sending = ref(false)

async function RePost(e) {
  e.preventDefault()
  if (sending.value) return
  sending.value = true
  const commentType = props.type || 'news'
  const data = await postCommentResponse(props.id, props.post_id, text.value, commentType)
  textA.value = data.text
  sending.value = false
  setTimeout(() => { textA.value = '' }, 3000)
  if (!data.error) emits('close')
}

</script>

<style scoped>
.commFeed .top {
  height: 50px;
  margin: 0;
}

.commFeed .content textarea {
  height: 90px;
}
</style>
